import { createAsyncThunk, createSlice, nanoid } from "@reduxjs/toolkit";
import FirmalarRoutePoints from "../../utils/firmalarRoutePoints";
import axios from "axios";
import { setResultModalData, showModal, showNestedModal } from "../modal/modalSlice";
import axiosInstance from "../../axios/axiosInstance";

const initialState = {
    isOrtaklariList: [],
    companyProjectNames: [],
    searchCompany: null,
    isSearchCompany: false,
    
    selectedProject: null,
    selectedLoadOwner: null,
    projectUpdateMessages: "",

    getIsLoading:false,
    getIsError:false,

    addIsLoading: false,
    addIsError:false,

    deleteIsLoading:false,
    deleteIsError:false,
}

//! kendine yükveren oluşturma
export const addPersonalLoadOwner = createAsyncThunk("companies/addPersonalLoadOwner", async(body, thunkApi) => {
    try{
        const {data} = await axiosInstance.post(`/Auth/RegisterCompany`, body)
        if(data.statusCode === 200){
          thunkApi.dispatch(showModal("result"))
          thunkApi.dispatch(setResultModalData({msg: "Kayıt işleminiz başarılı bir şekilde gerçekleştirilmiştir", resultType: "success", btnText1: "Harika"}))
          thunkApi.dispatch(setSearchCompany(null))
          thunkApi.dispatch(setIsSearchCompany(false))
        }
        
        return data.data
    }catch(error){
        return thunkApi.rejectWithValue(error)
    }
  })

  export const getPersonalLoadOwners = createAsyncThunk("companies/getPersonalLoadOwners", async({companyName = ""}, thunkApi) => {
    try{
        
        const {data} = await axiosInstance.get(`/Companies/GetCompanyProjectInfo?CompanyName=${companyName}`)
        
        return data.data
    }catch(error){
        return thunkApi.rejectWithValue(error)
    }
  })

  //! proje oluşturma
  
  export const createCompaniesProject = createAsyncThunk("companies/createCompaniesProject", async(body, thunkApi) => {
    try{
        const {data} = await axiosInstance.post(`/Companies/CreateCompaniesProject`, body)
        
        if(data.statusCode === 200){
          thunkApi.dispatch(showModal("result"))
          thunkApi.dispatch(setResultModalData({msg: "Proje oluşturma isteği gönderildi. Onay alındığı zaman proje oluşturulacak.", resultType: "success", btnText1: "Harika"}))
          thunkApi.dispatch(setSearchCompany(null))
          thunkApi.dispatch(setIsSearchCompany(false))
        }
        
        return data.data
    }catch(error){
        thunkApi.dispatch(showModal("result"))
        thunkApi.dispatch(setResultModalData({msg: error.response.data.ErrorDto.Errors[0], resultType: "error", btnText1: "Kapat"}))
        return thunkApi.rejectWithValue(error)
    }
  })

  export const companiesProjectApprove = createAsyncThunk("companies/companiesProjectApprove", async(body, thunkApi) => {
    try{
        
        const {data} = await axiosInstance.post(`/Companies/ApprovedCompaniesProject`, body)
        if(data.statusCode === 200){
          thunkApi.dispatch(showModal("result"))
          thunkApi.dispatch(setResultModalData({msg: `${body?.isApproved === true ? "Onaylama" : "Reddetme"} işlemi başarılı bir şekilde gerçekleştirildi.`, resultType: "success", btnText1: "Harika"}))
        }
        
        return data.data
    }catch(error){
        return thunkApi.rejectWithValue(error)
    }
  })

  //! iş ortakları proje isimleri
   
  export const getCompanyProjectName = createAsyncThunk("companies/getCompanyProjectName", async(_, thunkApi) => {
    try{
        
        const {data} = await axiosInstance.get(`/Companies/GetCompanyProjectName`)
        
        return data.data
    }catch(error){
        return thunkApi.rejectWithValue(error)
    }
  })

  
  export const getCompanyVergiNo = createAsyncThunk("companies/getCompanyVergiNo", async( query, thunkApi) => {
    try{
        
        const {data} = await axiosInstance.get(`/Companies/GetByVergiNo?VergiNo=${query}`)
        
        return data.data
    }catch(error){
        
        return thunkApi.rejectWithValue(error)
    }
  })
  

  export const updateCompanyProject = createAsyncThunk("companies/UpdateCompanyProject", async( body, thunkApi) => {
    try{
        
        const {data} = await axiosInstance.post(`Companies/UpdateCompanyProject`, body)
        if(data.statusCode === 200){
            thunkApi.dispatch(showNestedModal("result"));
            thunkApi.dispatch(setResultModalData({ msg: "Güncelleme işlemi başarılı bir şekilde gerçekleştirildi.", resultType: "success", btnText1: "Kapat",}));
        }
        return data.data
    }catch(error){
        thunkApi.dispatch(showNestedModal("result"));
        thunkApi.dispatch(setResultModalData({ msg: error.response.data.ErrorDto.Errors[0], resultType: "error", btnText1: "Kapat",}));
        return thunkApi.rejectWithValue(error)
    }
  })

  export const deleteProjectLoadOwner = createAsyncThunk("companies/deleteProjectLoadOwner", async( body, thunkApi) => {
    try{
        
        const {data} = await axiosInstance.post(`Companies/DeleteLoadOwner`, body)
        if(data.message){
            thunkApi.dispatch(showNestedModal(null))
        }
        return data
    }catch(error){
        
        return thunkApi.rejectWithValue(error)
    }
  })

  export const deleteProject = createAsyncThunk("companies/deleteProject", async(id, thunkApi) => {
    try{
        const {data} = await axiosInstance.delete(`Companies/DeleteCompanyProject?id=${id}`)
        if(data.statusCode === 200){
            thunkApi.dispatch(showModal("result"))
            thunkApi.dispatch(setResultModalData({msg: "Silme işlemi başarılı bir şekilde gerçekleştirildi.", resultType: "success", btnText1: "Kapat"}))
        }
        
        return data
    }catch(error){
        
        return thunkApi.rejectWithValue(error)
    }
  })
  

const isOrtaklariSlice = createSlice({
    name:"isOrtaklari",
    initialState,
    reducers:{
        setSearchCompany:(state, action) => {
            state.searchCompany = action.payload
        },
        setIsSearchCompany:(state, action) => {
            state.isSearchCompany = action.payload
        },
        setSelectedProject: (state, action) =>  {
            state.selectedProject = action.payload
        },
        setProjectUpdateMessages: (state, action) => {
            state.projectUpdateMessages = action.payload
        },
        setSelectedLoadOwner: (state, action) => {
            state.selectedLoadOwner = action.payload
        }
    },
    extraReducers: (builder) => {
        builder
        .addCase(addPersonalLoadOwner.pending, (state) => {
            state.getIsLoading = true;
        })
        .addCase(addPersonalLoadOwner.fulfilled, (state, action) => {
            state.getIsLoading = false;
            state.isOrtaklariList = action.payload.$values.map((item) => {
                return {
                    ...item,
                    loadOwnerCompanyDtos: item.loadOwnerCompanyDtos.$values
                }
            })
        })
        .addCase(addPersonalLoadOwner.rejected, (state) => {
            state.getIsLoading = false;
            state.getIsError = false;
        })

        .addCase(getPersonalLoadOwners.pending, (state) => {
            state.getIsLoading = true;
        })
        .addCase(getPersonalLoadOwners.fulfilled, (state, action) => {
            state.getIsLoading = false;
            
            state.isOrtaklariList = action.payload.$values.map((item) => {
                return {
                    ...item,
                    loadOwnerCompanyDtos: item.loadOwnerCompanyDtos.$values
                }
            })
        })
        .addCase(getPersonalLoadOwners.rejected, (state) => {
            state.getIsLoading = false;
            state.getIsError = false;
        })

        .addCase(createCompaniesProject.pending, (state) => {
            state.getIsLoading = true;
        })
        .addCase(createCompaniesProject.fulfilled, (state, action) => {
            
            state.getIsLoading = false;
        })
        .addCase(createCompaniesProject.rejected, (state) => {
            state.getIsLoading = false;
            state.getIsError = true;
        })
        
        .addCase(companiesProjectApprove.pending, (state) => {
            state.getIsLoading = true;
        })
        .addCase(companiesProjectApprove.fulfilled, (state, action) => {
            state.getIsLoading = false;
            state.isOrtaklariList = state.isOrtaklariList?.map((item) => {
                if(item?.id === action.payload?.id){
                    return {
                        ...action.payload,
                        loadOwnerCompanyDtos: action.payload.loadOwnerCompanyDtos.$values
                    }
                }else{
                    return item
                }
            })
        })
        .addCase(companiesProjectApprove.rejected, (state) => {
            state.getIsLoading = false;
            state.getIsError = true;
        })
        
        
        .addCase(getCompanyProjectName.pending, (state) => {
            state.getIsLoading = true;
        })
        .addCase(getCompanyProjectName.fulfilled, (state, action) => {
            state.getIsLoading = false;
            state.companyProjectNames = action.payload.$values
        })
        .addCase(getCompanyProjectName.rejected, (state) => {
            state.getIsLoading = false;
            state.getIsError = false;
        })

        .addCase(getCompanyVergiNo.pending, (state) => {
            state.getIsLoading = true;
        })
        .addCase(getCompanyVergiNo.fulfilled, (state, action) => {
            state.getIsLoading = false;
            state.searchCompany = action.payload
            state.isSearchCompany = true
        })
        .addCase(getCompanyVergiNo.rejected, (state) => {
            state.getIsLoading = false;
            state.getIsError = false;
        })

        .addCase(updateCompanyProject.pending, (state) => {
            state.addIsLoading = true;
        })
        .addCase(updateCompanyProject.fulfilled, (state, action) => {
            state.addIsLoading = false;
            state.selectedProject = {...state.selectedProject, projectName: action.payload.projectName, loadOwnerCompanyDtos: action.payload.loadOwnerCompanyDtos.$values}
            state.isOrtaklariList = state.isOrtaklariList.map((item) => {
                if(item.id === action.payload.id){
                    return {
                        ...item,
                        projectName: action.payload.projectName, 
                        loadOwnerCompanyDtos: action.payload.loadOwnerCompanyDtos.$values
                    }
                }else{
                    return item
                }
            })
        })
        .addCase(updateCompanyProject.rejected, (state) => {
            state.addIsLoading = false;
            state.addIsError = false;
        })
        
        .addCase(deleteProjectLoadOwner.pending, (state) => {
            state.deleteIsLoading = true;
        })
        .addCase(deleteProjectLoadOwner.fulfilled, (state, action) => {
            state.deleteIsLoading = false;
            state.selectedProject = {...state.selectedProject, loadOwnerCompanyDtos: state.selectedProject.loadOwnerCompanyDtos.filter((filter)=>{
                return filter?.loadOwnerCompanyId !== action.payload.message
            })}
            state.isOrtaklariList = state.isOrtaklariList.map((item) => {
                return {
                    ...item,
                    loadOwnerCompanyDtos: item.loadOwnerCompanyDtos.filter((innerItem) => {
                        return innerItem?.loadOwnerCompanyId !== action.payload.message
                    })
                }
            })
        })
        .addCase(deleteProjectLoadOwner.rejected, (state) => {
            state.deleteIsLoading = false;
            state.deleteIsError = false;
        })
        
        .addCase(deleteProject.pending, (state) => {
            state.deleteIsLoading = true;
        })
        .addCase(deleteProject.fulfilled, (state, action) => {
            state.deleteIsLoading = false;
           
            state.isOrtaklariList = state.isOrtaklariList.filter((item)=> {
                return item.id !== action.payload.message
            })
        })
        .addCase(deleteProject.rejected, (state) => {
            state.deleteIsLoading = false;
            state.deleteIsError = false;
        })
    }
})

export const {setSearchCompany, setIsSearchCompany, setSelectedProject, setSelectedLoadOwner} = isOrtaklariSlice.actions
export default isOrtaklariSlice.reducer